import ColumnName from './ColumnName';

class AggregateColumn {
  constructor(
    readonly _alias: string,
    readonly _name: string,
    readonly _aggregation: Nullable<string>,
  ) {}

  static build(objFromServer: AggregateColumn) {
    return new AggregateColumn(
      objFromServer._alias,
      objFromServer._name,
      objFromServer._aggregation,
    );
  }

  static fromColumn(columnName: ColumnName, aggregation: Nullable<string>) {
    return new AggregateColumn(
      columnName.alias(),
      columnName.name(),
      aggregation,
    );
  }

  alias() {
    return this._alias;
  }

  name() {
    return this._name;
  }

  columnName() {
    return new ColumnName(this._alias, this._name);
  }

  aggregation() {
    return this._aggregation;
  }

  equals(aggCol: AggregateColumn) {
    return this.columnName().equals(aggCol.columnName());
  }

  toString() {
    return this.columnName().toString();
  }
}

export default AggregateColumn;
